export async function getAgents(context) {

    let document = context.getters['getInsuranceDocument'];
    if (Array.isArray(document)){
        document = document[0];
    }
    let id = document.hasOwnProperty('id') ? document.id : document
    await axios.get('/insurance_agents/insurance_document/' + id)
        .then(function (response) {
            context.commit('setInsuranceAgent', response.data.data.agent)
            context.commit('setInsuranceAgents', response.data.data.agents)
        })
        .catch((err) => {
            console.info('not load agents')
            console.error(err)
        })
}
